// ============================================================================
// CANCUN100 — marca.js  (APP 2/09 · F7/F8: logo oficial y eslogan, en UN solo lugar)
// ----------------------------------------------------------------------------
// Imágenes en public/marca/ (sacadas del prototipo login-y-panel-2.0.html, que a su vez salen de
// public/icon-512.png y src/pdf/cancun100-logo.png): icono cuadrado + logotipo «cancun100» en dos versiones
// (texto oscuro para fondo claro · texto blanco para fondo oscuro o barra de color), fondo transparente.
// ESLOGAN: opción A, decidida por Marco el 2-nov 21:17.
// ============================================================================
import React from 'react';

export const ESLOGAN = {
  titulo: 'Aquí empieza cada viaje a',
  enfasis: 'Cancún',
  cierre: '.',
  sub: 'Tu sala de ventas, tus folios y tus comisiones en un solo lugar.',
};

export const LOGO_ICONO = '/marca/icono-160.png';
export const LOGOTIPO_CLARO = '/marca/logotipo-claro.png';   // texto oscuro → para fondo claro
export const LOGOTIPO_OSCURO = '/marca/logotipo-oscuro.png'; // texto blanco → para fondo oscuro o barra de color

// Icono + logotipo. `sobre`: 'claro' (fondo claro → texto oscuro) · 'oscuro' (fondo oscuro o de color → texto blanco).
export function Logotipo({ sobre = 'claro', alto = 26, icono = true, gap = 10, style, subtitulo }) {
  const src = sobre === 'oscuro' ? LOGOTIPO_OSCURO : LOGOTIPO_CLARO;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap, minWidth: 0, ...style }}>
      {icono && <img src={LOGO_ICONO} alt="" aria-hidden="true" style={{ width: Math.round(alto * 1.45), height: Math.round(alto * 1.45), flex: 'none', filter: 'drop-shadow(0 4px 10px rgba(0,0,0,.25))' }} />}
      <span style={{ display: 'inline-flex', flexDirection: 'column', minWidth: 0 }}>
        <img src={src} alt="cancun100" style={{ height: alto, width: 'auto', display: 'block' }} />
        {subtitulo && <span style={{ fontSize: Math.max(10, Math.round(alto * 0.42)), opacity: 0.85, marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{subtitulo}</span>}
      </span>
    </span>
  );
}
